import { useMobileBreakpoint } from "@ob/theme";
import { BoxProps, Stack } from "@mui/material";
import { FC, PropsWithChildren } from "react";

const isMobileDevice = typeof window.screen.orientation === "number";
export const Body: FC<PropsWithChildren & BoxProps> = ({ children }) => {
  const { isMobile } = useMobileBreakpoint();
  const h = isMobileDevice ? 0 : 130;
  const minHeight =
    isMobile || isMobileDevice ? `calc(55vh + ${h}px)` : "unset";
  return (
    <Stack
      className="layout--body"
      maxWidth={620}
      flexDirection="column"
      flex={1}
      width="100%"
      alignSelf="center"
      mt={6}
      mb={10}
      minHeight={minHeight}
    >
      {children}
    </Stack>
  );
};
